import { ChangeDetectionStrategy, Component } from "@angular/core";
import { CampaignType } from "@front/m19-api-client";
import { BulkUploadLayoutComponent } from "@m19-board/bulk-upload/bulk-upload-layout/bulk-upload-layout.component";
import { provideStrategyBulkUpload } from "@m19-board/services/bulk-upload/bulk-upload.tokens";
import { SdBulkUploadHandler } from "@m19-board/services/bulk-upload/sd/sd-bulk-upload-handler.service";

@Component({
  selector: "app-sd-bulk-upload-page",
  imports: [BulkUploadLayoutComponent],
  providers: [provideStrategyBulkUpload(CampaignType.SD, SdBulkUploadHandler)],
  template: `<app-bulk-upload-layout />`,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SdBulkUploadPageComponent {}
